import React, { memo } from 'react';

import { useFieldProps } from 'hooks';
import style from './index.module.scss';
import { Box, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { InputBrowse } from 'components/input-browse';
import { Alert, AlertTitle } from '@mui/material';
import { useTranslate } from 'hooks/use-translate';
import { FormFields, Left } from 'utils/types';

type Model = Left<{ excelFile: string }>;
interface Props {
  isLoading: boolean;
}

export const MigrateFroExel = memo<Props>(({ isLoading }) => {
  const { tp } = useTranslate();
  const {
    control,
    formState: { errors },
  } = useFormContext<FormFields<Model>>();
  const getInputProps = useFieldProps({ errors, emptyHelperText: '' });

  return (
    <div className={style.root}>
      <Box
        sx={{
          p: '1.2rem 1.6rem 0',
        }}
      >
        <Typography color={'secondary'} style={{ fontWeight: 'bold' }}>
          {tp('migrate-from-excel')}
        </Typography>
        <Controller
          control={control}
          name={'excelFile'}
          render={({ field: renderProps }) => (
            <InputBrowse {...getInputProps(renderProps)} disabled={isLoading} />
          )}
        />
      </Box>
      <Alert severity="info">
        <AlertTitle>{tp('patient-excel-info-title')}</AlertTitle>
        {tp('patient-excel-info-description')}
      </Alert>
    </div>
  );
});
